import { AcquisitionContextService } from '../../../context/child/acquisition-context.service';
import { CustomerContextService } from '../../../context/child/customer-context.service';
import { ContextInterface } from '../../../context/context.interface';
import { Promotion } from './promotion.class';
import { IPromotions } from './promotion.interface';

export class Customer extends Promotion {
    public static contractTypesStandard: string[] = ['FAI_FNB', 'FAI', 'FNB'];

    protected static checkContexts(promotion: IPromotions, context: ContextInterface): boolean {
        if (
            context instanceof AcquisitionContextService &&
            (promotion.conditions.acquisition ||
                (promotion.conditions.client && promotion.conditions.client.incitation.enabled))
        ) {
            return true;
        } else if (
            context instanceof CustomerContextService &&
            context.contracts.length === 0 &&
            promotion.conditions.acquisition
        ) {
            return true;
        } else if (context instanceof CustomerContextService && promotion.conditions.client) {
            let hasContract = [];

            if (context.isStandardForPromo()) {
                if (promotion.conditions.callOperator) {
                    hasContract = promotion.conditions.client.contrats.filter((item) =>
                        this.contractTypesStandard.includes(item),
                    );
                }
            }

            const hasContractType =
                this.hasContractType(promotion.conditions.client.contrats, context.contracts) &&
                this.checkStatut(promotion.conditions.client.statut, context.statut);
            promotion.hasContractType =
                (hasContractType && context.contracts.length > 0) ||
                (context.isPremiumForPromo() && promotion.conditions.callOperator) ||
                hasContract.length > 0;
            return promotion.hasContractType || promotion.conditions.client.incitation.enabled;
        }
        return false;
    }
}
